import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setMessage } from "./message";
import EventBus from "../../utils/EventBus";
import EmailApi from "../../Api/emailtemplate"


export const fetchEmailTemplates = createAsyncThunk("template/fetchEmailTemplates", async (params, thunkAPI) => {
    try {
        const response = await EmailApi.getEmailTemplates(params);
        return response.data;
    } catch (error) {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            EventBus.dispatch("logout");
        }
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        thunkAPI.dispatch(setMessage(message));
        return thunkAPI.rejectWithValue(message);
    }
});


export const fetchEmailTemplatesById = createAsyncThunk("template/fetchEmailTemplatesById", async (params, thunkAPI) => {
    try {
        const response = await EmailApi.getEmailTemplateById(params);
        console.log("res",response.data)
        return response.data;
    } catch (error) {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            EventBus.dispatch("logout");
        }
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        thunkAPI.dispatch(setMessage(message));
        return thunkAPI.rejectWithValue(message);
    }
});



export const addEmailTemplate = createAsyncThunk("template/addEmailTemplate", async (formData, thunkAPI) => {
    try {
        const response = await EmailApi.addEmailTemplate(formData);
        const message=(response.message)
    
        thunkAPI.dispatch(setMessage(message))
        return response.data;
    } catch (error) {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            EventBus.dispatch("logout");
        }
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        thunkAPI.dispatch(setMessage(message));
        return thunkAPI.rejectWithValue(message);
    }
});



export const updateEmailTemplate = createAsyncThunk("template/updateEmailTemplate", async ({ id, formData }, thunkAPI) => {
    try {
        const response = await EmailApi.updateEmailTemplate(id, formData);
        const message=(response.message)
    
        thunkAPI.dispatch(setMessage(message))
        return response;
    } catch (error) {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            EventBus.dispatch("logout");
        }
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        thunkAPI.dispatch(setMessage(message));
        return thunkAPI.rejectWithValue(message);
    }
});


export const deleteEmailTemplate = createAsyncThunk("template/deleteEmailTemplate", async (id, thunkAPI) => {
    try {
        const response = await EmailApi.deleteEmailTemplate(id);
        return id;
    } catch (error) {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            EventBus.dispatch("logout");
        }
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        thunkAPI.dispatch(setMessage(message));
        return thunkAPI.rejectWithValue(message);
    }
});

const templateSlice = createSlice({
    name: "template",
    initialState: {
        emailtemplates: [],
        selectedTemplate: null, 
        totalPages: "",
        totalCount: 0,
        error: null,
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchEmailTemplates.fulfilled, (state, action) => {
                state.emailtemplates = action.payload.data;
                state.totalPages = action.payload.totalPages;
                state.totalCount = action.payload.totalCount;
            })
            .addCase(addEmailTemplate.fulfilled, (state, action) => {
                state.emailtemplates.push(action.payload);
            })

            .addCase(fetchEmailTemplatesById.fulfilled, (state, action) => {
                state.selectedTemplate = action.payload;
                console.log("ac",action.payload)
            })
            .addCase(fetchEmailTemplatesById.rejected, (state, action) => {
                state.error = action.payload;
            })

            .addCase(updateEmailTemplate.fulfilled, (state, action) => {
                console.log("res",action.payload.data)
                const {
                    arg: { id },
                  } = action.meta;
                  if(id){
                state.emailtemplates = state.emailtemplates.map((template) =>
                    template.id === id ? action.payload.data : template
                );

            }
            })          
            
            .addCase(deleteEmailTemplate.fulfilled, (state, action) => {
                state.emailtemplates = state.emailtemplates.filter((template) => template.id !== action.payload);
            })
            .addCase(fetchEmailTemplates.rejected, (state, action) => {
                state.error = action.payload;
            })
            .addCase(addEmailTemplate.rejected, (state, action) => {
                state.error = action.payload;
            })
            .addCase(updateEmailTemplate.rejected, (state, action) => {
                state.error = action.payload;
            })
            .addCase(deleteEmailTemplate.rejected, (state, action) => {
                state.error = action.payload;
            });
    },
});

const { reducer } = templateSlice;
export default reducer;
